import { useEffect } from 'react';
import { TOPUP_PROPS_EVENT } from "../constants";

/**
 * Компонент-цель для разделенного режима работы
 * Отправляет пропсы через событие компоненту-источнику
 * Используется в основном приложении для передачи данных в отвязанный бандл
 */
export var DecoupledTopUpBalanceTarget = function DecoupledTopUpBalanceTarget(props) {
  useEffect(function () {
    // Отправка события с данными для пополнения
    document.dispatchEvent(new CustomEvent(TOPUP_PROPS_EVENT, {
      detail: props
    }));
  }, [props]);

  // Компонент ничего не рендерит, только передает данные
  return null;
};